"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shuffler = void 0;
const subtractive_generator_1 = require("./subtractive-generator");
class Shuffler {
    static shuffledDeck(seed, deck) {
        const generator = new subtractive_generator_1.SubtractiveGenerator(seed);
        const result = deck.map((item) => ({
            card: item,
            number: generator.next(),
        }));
        result.sort((a, b) => a.number - b.number);
        return result.map((item) => item.card);
    }
}
exports.Shuffler = Shuffler;
